"use strict";
var Observable_1 = require('../../Observable');
var last_1 = require('../../operator/last');
Observable_1.Observable.prototype.last = last_1.last;
//# sourceMappingURL=last.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/rxjs/add/operator/last.js
 ** module id = 776
 ** module chunks = 0
 **/